var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRestaurant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.25,
    height: 17.999,
    viewBox: "0 0 11.25 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-restaurant",
    "data-name": "Icon map-restaurant",
    d: "M11.7,1.069V5.22h-.75V1.095a.375.375,0,0,0-.75,0V5.22H9.45V1.081a.376.376,0,0,0-.75-.012V5.22H7.95V1.1a.375.375,0,0,0-.75-.02V6.505A1.415,1.415,0,0,0,8.7,7.8v9.791a1.125,1.125,0,1,0,2.25,0V7.8a1.5,1.5,0,0,0,1.5-1.21V1.081a.376.376,0,0,0-.75-.012Zm3.375,1.15v9.375h.75v6c0,1.5,2.625,1.5,2.625,0V2.22C18.45.345,15.075.345,15.075,2.22Z",
    transform: "translate(-7.2 -0.72)",
    fill: "#364436"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestaurant);
export default __webpack_public_path__ + "static/media/icon-restaurant.ec46af24cd191a220fffcdb54ce5142c.svg";
export { ForwardRef as ReactComponent };